import OAuthService from 'src/app/auth/services/oAuthService';
import { buildLineKey } from '../utils/budgetValueUtils';

export const buildUrl = (path, params) => {
    if (!params || Object.keys(params).length === 0) {
        return `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${path}`;
    }
    const query = new URLSearchParams(params).toString();
    return `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${path}?${query}`;
};

export const fetchLatestBudgets = async (budgetType, year, territoryId) => {
    const url = buildUrl(`/api/salesBudget/v2/get-sales-budgets`, { budgetType: String(budgetType).toUpperCase(), year });
    const response = await OAuthService.getList(url);
    const list = Array.isArray(response.data) ? response.data : [];
    const territoryDoc = list.find(t => String(t.budgetDetails?.territoryId) === String(territoryId)) || null;

    const linesById = new Map();
    list.forEach(t => (t.budgets || []).forEach(b => {
        if (b.id) linesById.set(String(b.id), b);
    }));

    const linesByKey = new Map();
    (territoryDoc?.budgets || []).forEach(b => {
        linesByKey.set(buildLineKey(b.customerNum, b.showroomNum, b.orderCategory, b.productNum, b.month), b);
    });

    return { territoryDoc, linesById, linesByKey };
};
